var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOktoCashStorePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2988_83)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9683 7.40846C32.8863 3.19851 27.5699 0.878906 22.0001 0.878906C16.4251 0.878906 11.1087 3.19851 7.02407 7.41113C2.8781 11.6877 0.601158 17.4334 0.779794 23.1765C1.28371 39.451 20.4537 52.1235 21.2723 52.6541L21.9895 53.1207L22.7147 52.6621C23.5305 52.1449 42.714 39.779 43.2205 23.1738C43.3965 17.4334 41.1169 11.6851 36.9683 7.40846Z",
    fill: "#0069B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2988_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOktoCashStorePin);
export default __webpack_public_path__ + "static/media/OktoCashStorePin.5856a4562b524c9e62b3029ba307f56d.svg";
export { ForwardRef as ReactComponent };